import { render } from "./DeliveryEditPage.vue?vue&type=template&id=427127fa"
import script from "./DeliveryEditPage.vue?vue&type=script&lang=js"
export * from "./DeliveryEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__